import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import CheckExceptionHomePage from "../containers/CheckExceptionHomePage";
import HomePageChecksExpanded from "../containers/HomePageChecksExpanded";
import SuspectItemDetails from "../details/SuspectItemDetails";

import ScrubIcon from "@material-ui/icons/VisibilityOutlined";
import InfoIcon from "@material-ui/icons/InfoOutlined";

import ExpandAllIcon from "@material-ui/icons/ExpandMoreOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";

import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  spacer: {
    flex: "1 1 100%",
  },

  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

class HomePageChecks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      minutesLeft: 0,
      checkAccounts: [],
      allAccounts: [],
      selectedAccountObject: {},
      selectedAccountIndex: 0,
      noExceptions: false,
      scrubMode: false,
      expanded: false,
      crtTime: "",
      searchInProgress: false,
      retcodes: [],
      viewPopup: false,
      isPreferredAcctsOnly: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ selectedAccountIndex: 0 });
    this.setState({ scrubMode: false });
    this.setState({ expanded: false });
    this.setState({ isPreferredAcctsOnly: false });
    this.componentDidMount();
  }

  componentDidMount() {
    this.setState({ noExceptions: false });
    this.setState({ expanded: false });
    this.setState({ searchInProgress: true });
    fetch("on_exception_summary_request_chk", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ searchInProgress: false });
        } else {
          this.setState({ searchInProgress: false });
          this.setState({ allAccounts: reply.checkExceptions });
          this.setState({ checkAccounts: reply.checkExceptions });
          this.setState({ minutesLeft: reply.minutesLeft });
          if (reply.checkExceptions.length === 0) {
            this.setState({ noExceptions: true });
          }
          var today = new Date();
          var time =
            ("0" + today.getHours()).slice(-2) +
            ":" +
            ("0" + today.getMinutes()).slice(-2);
          this.setState({ crtTime: time });
        }
      })
      .catch((error) => {
        this.setState({ searchInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  setPreferredAcctsData(checked) {
    if (!checked) {
      this.setState({ checkAccounts: this.state.allAccounts });
    } else {
      const myArray = this.state.allAccounts;
      const myFilter = this.props.prefs.accounts;

      const myArrayFiltered = myArray.filter((el) => {
        return myFilter.some((f) => {
          return f.transit === el.transit && f.accounts.includes(el.account);
        });
      });
      this.setState({
        checkAccounts: myArrayFiltered,
      });
    }
  }

  handlePreferredAcctsOnly(e) {
    this.setState({ isPreferredAcctsOnly: e.target.checked });
    this.setPreferredAcctsData(e.target.checked);
  }

  handleSelectAccount(e, index) {
    this.setState({ selectedAccountIndex: index });
    let selectedObject;
    selectedObject = this.state.checkAccounts[index - 1];
    this.setState({ selectedAccountObject: selectedObject });
  }

  handleUnselectAccount(e) {
    this.setState({ selectedAccountIndex: 0 });
    this.componentDidMount();
  }

  handleScrub(event) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    fetch("on_init_suspect_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        let reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ retcodes: reply.returnCodes });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });

    this.setState({ scrubMode: true });
  }

  handleExpand(event) {
    this.setState({ expanded: true });
  }

  render() {
    let checkItems = this.state.checkAccounts;
    let url = "on_search_rejected_items_request";
    let { t } = this.props;
    const { classes } = this.props;
    return (
      <div>
        {this.state.errorString.length > 0 && (
          <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
        )}
        {this.state.noExceptions &&
          this.state.minutesLeft >= 0 &&
          !this.state.searchInProgress && (
            <h3 style={{ color: "primary" }}>
              &nbsp;&nbsp;{t("noItemFound.label")}{" "}
            </h3>
          )}
        {this.state.noExceptions &&
          this.state.minutesLeft < 0 &&
          !this.state.searchInProgress && (
            <h4 style={{ color: "red" }}>
              &nbsp;&nbsp;{t("suspectReviewNotAvi.label")}
              <strong> {-this.state.minutesLeft} </strong>{" "}
              {t("minutesAs.label")} {this.state.crtTime}).
            </h4>
          )}
        {this.state.checkAccounts.length === 0 &&
          this.state.errorString.length === 0 &&
          this.state.searchInProgress && (
            <div>
              <br></br>
              <CircularProgress className={classes.progress} />
            </div>
          )}
        {this.state.selectedAccountIndex !== 0 && (
          <CheckExceptionHomePage
            history={this.props.history}
            uiExclusionsList={this.props.uiExclusionsList}
            viewOnly={this.props.viewOnly}
            secureToken={this.props.secureToken}
            account={this.state.selectedAccountObject}
            onClose={this.onClosePopup}
          />
        )}
        {this.state.scrubMode && (
          <SuspectItemDetails
            scrub={true}
            fromHome={true}
            uiExclusionsList={this.props.uiExclusionsList}
            viewOnly={this.props.viewOnly}
            secureToken={this.props.secureToken}
            history={this.props.history}
            onClosePopup={this.onClosePopup}
            returnCodes={this.state.retcodes}
            url={url}
          />
        )}
        {this.state.errorString.length === 0 &&
          this.state.selectedAccountIndex === 0 &&
          !this.state.scrubMode && (
            <div>
              {this.state.checkAccounts.length > 0 && this.state.expanded && (
                <HomePageChecksExpanded
                  history={this.props.history}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                  accounts={this.state.checkAccounts}
                  onClose={this.onClosePopup}
                />
              )}
              {!this.state.expanded && (
                <div style={{ margin: 20 }}>
                  <Typography variant="h6" color="primary">
                    {t("checkExceptions.label")}
                    <Tooltip
                      classes={{ tooltip: classes.customWidth }}
                      title={<div>{t("snapshot.tip")}</div>}
                    >
                      <InfoIcon color="primary" />
                    </Tooltip>
                    &nbsp;&nbsp;
                    {this.state.checkAccounts.length > 0 && (
                      <>
                        <Button
                          color="primary"
                          onClick={(event) => this.handleScrub(event)}
                        >
                          <ScrubIcon />
                          &nbsp;{t("scrub.button")}
                        </Button>
                        <Button
                          color="primary"
                          style={{ position: "absolute", right: 20 }}
                          onClick={(event) => this.handleExpand(event)}
                          disabled={this.state.expanded}
                        >
                          <ExpandAllIcon />
                          &nbsp;{t("expandAll.button")}
                        </Button>
                      </>
                    )}
                  </Typography>
                  <Typography variant="body1" color="error">
                    {t("youHave.label")}
                    <strong> {this.state.minutesLeft} </strong>{" "}
                    {t("minuteLeft.label")}
                  </Typography>
                  <Typography color="primary" variant="body1">
                    {" "}
                    {t("notePendingIncluded.label")}
                  </Typography>
                  <Paper>
                    &nbsp;&nbsp;
                    {this.state.minutesLeft > 0 && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={this.state.isPreferredAcctsOnly}
                            onChange={(event) =>
                              this.handlePreferredAcctsOnly(event)
                            }
                          />
                        }
                        label={t("includePreferredAcctsOnly.label")}
                      />
                    )}
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Typography
                              variant="subtitle1"
                              color="primary"
                              style={{ fontWeight: 600 }}
                            >
                              {t("transit.header")}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle1"
                              color="primary"
                              style={{ fontWeight: 600 }}
                            >
                              {t("account.header")}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle1"
                              color="primary"
                              style={{ fontWeight: 600 }}
                            >
                              {t("numberExceptions.header")}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {checkItems.map((item) => {
                          return (
                            <TableRow
                              hover
                              className={classes.tableRow}
                              onClick={(event) =>
                                this.handleSelectAccount(event, item.index)
                              }
                              key={item.index}
                              title={t("selectSuspect.label")}
                            >
                              <TableCell component="th" scope="row">
                                {item.transit}
                              </TableCell>
                              <TableCell>{item.account}</TableCell>
                              <TableCell>{item.numExceptions}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                      {this.state.checkAccounts.length === 0 && (
                        <Typography variant="h12" color="primary">
                          {t("noData.label")}
                        </Typography>
                      )}
                    </Table>
                  </Paper>
                </div>
              )}
            </div>
          )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePageChecks));
